import { Helmet } from "react-helmet-async";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://renviahealth.com";
const DEFAULT_OG = `${SITE_URL}/brand/renvia-horizontal-color-transparent.png`;

const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "MedicalOrganization",
  name: "RenVia",
  legalName: "RenVia, Inc.",
  url: SITE_URL,
  logo: `${SITE_URL}/brand/renvia-horizontal-color-transparent.png`,
  description:
    "RenVia is a trusted U.S. commercialization partner for Oculus Biologics and the XcellerEYES lyophilized amniotic membrane product line.",
  medicalSpecialty: ["Ophthalmology", "Optometry"],
  areaServed: { "@type": "Country", name: "United States" },
  email: "info@renviahealth.com",
  sameAs: [],
};

export default function SEO({
  title,
  description,
  path = "/",
  image,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const url = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_OG;
  const fullTitle = title
    ? `${title} · RenVia`
    : "RenVia — Restoring Ocular Health Through Innovation";
  const desc =
    description ||
    "RenVia is a trusted U.S. commercialization partner for Oculus Biologics and the XcellerEYES lyophilized amniotic membrane product line.";

  // Always include the Organization JSON-LD; merge page-specific if provided
  const ldList = [ORG_JSONLD].concat(jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : []);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="RenVia" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {/* Search Console verification (env-driven, no-op until set) */}
      {process.env.REACT_APP_GSC_VERIFICATION && (
        <meta
          name="google-site-verification"
          content={process.env.REACT_APP_GSC_VERIFICATION}
        />
      )}

      {ldList.map((ld, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(ld)}
        </script>
      ))}
    </Helmet>
  );
}
